var globalFunctions = {
    created: function () {
    },
    methods: {
        b64ToFile(b64Data, contentType, fileName) {
            var byteCharacters = atob(b64Data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);
            
            let file;
            try {
                file = new File([byteArray], fileName, {type: contentType, lastModified: Date.now()});
            } catch(e) {
                file = new Blob([byteArray], {type : contentType});
                file.name = fileName;
                file.fileName = fileName;
                file.lastModified = Date.now();
                file.lastModifiedDate = new Date(file.lastModified);
                file.webkitRelativePath = "";
            }
            return file;
        },
        b64ToBlob(b64Data, contentType) {
            var byteCharacters = atob(b64Data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            var blob = new Blob([byteArray], {type: contentType});

            return blob;
        },
        blobToFile(blob, fileName) {
            var file = new File([blob], fileName, {type: blob.type, lastModified: Date.now()});
            return file;
        }
    }
}

export default globalFunctions;